/** Date formatting for chat timestamps (server sends naive UTC). Pure module. */

export function parseUtcAware(dateString: string): Date {
  if (!dateString) return new Date();
  // Check for timezone: Z or +/-HH:MM format (grouped for clarity)
  const hasTZ = /Z|([+\-]\d{2}:?\d{2})$/.test(dateString);
  const normalized = hasTZ ? dateString : `${dateString}Z`;
  const d = new Date(normalized);
  return isNaN(d.getTime()) ? new Date(dateString) : d;
}

export function formatDateTime(dateString: string): string {
  return parseUtcAware(dateString).toLocaleString([], {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  } as any);
}
